var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { forwardRef, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FAVORITE_URL, LOGOUT_URL } from "../../../constants/config";
import { useAuth } from "../../../contexts/AuthProvider";
import { getStationUrl, setClickLogFn } from "../../../helpers";
import DarkMode from "../DarkMode";
var UserArea = forwardRef(function (props, ref) {
  var t = useTranslation().t;

  var _a = useAuth(),
      userId = _a.userId,
      noteNew = _a.noteNew;

  var lang = document.documentElement.lang;
  var logoutUrl = useMemo(function () {
    var szCurrentHref = document.location.href; // remove hash tag

    if (/(#)+(.*)$/.test(szCurrentHref)) {
      szCurrentHref = szCurrentHref.replace(RegExp.lastMatch, "");
    }

    return LOGOUT_URL + "?request_uri=" + encodeURIComponent(szCurrentHref);
  }, [document.location.href]);
  return React.createElement("div", __assign({
    id: "userArea",
    className: "loginUserMenu"
  }, props, {
    ref: ref
  }), React.createElement("ul", {
    className: "menuList"
  }, React.createElement("li", null, React.createElement("a", {
    href: getStationUrl(userId),
    target: "_blank",
    rel: "noopener noreferrer",
    className: "mybs",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "station"
    })
  }, React.createElement("em", null, React.createElement(Trans, null, "\uBC29\uC1A1\uAD6D")))), React.createElement("li", null, React.createElement("a", {
    href: FAVORITE_URL,
    className: "favorite",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "favorite"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "\uC990\uACA8\uCC3E\uAE30")))), React.createElement("li", null, React.createElement("a", {
    className: "my_item",
    href: "https://point.onlive.vn/mygift-quickview",
    target: "_top",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "item"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "\uB0B4 \uC544\uC774\uD15C")))), React.createElement("li", null, React.createElement("a", {
    className: "my_balloon",
    href: "https://point.onlive.vn/mygift-starballoon",
    target: "_top",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "balloon"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "\uB0B4 \uBCC4\uD48D\uC120")))), React.createElement("li", null, React.createElement("a", {
    className: "my_gd",
    href: "https://point.onlive.vn/mygift-subscription",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "subscription"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "\uB0B4 \uAD6C\uB3C5")))), React.createElement("li", null, React.createElement("a", {
    className: "my_stat",
    href: "https://broadstatistic.onlive.vn",
    target: "_top",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "profit"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "\uB0B4 \uD1B5\uACC4")))), React.createElement("li", null, React.createElement("a", {
    className: "my_message",
    href: "https://note.onlive.vn/app/index.php",
    target: "_top",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "note"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "\uB0B4 \uCABD\uC9C0")), " ", React.createElement("span", {
    className: "memo"
  }, noteNew), React.createElement("span", null, React.createElement(Trans, null, "\uAC1C")), noteNew > 0 && React.createElement("span", {
    className: "new"
  }, "New"))), React.createElement("li", null, React.createElement("a", {
    className: "my_dashboard",
    href: "https://dashboard.onlive.vn/index.php",
    target: "_top",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "dashboard"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "C\xE0i \u0111\u1EB7t ph\xE1t s\xF3ng thi\u1EBFt b\u1ECB b\xEAn ngo\xE0i")))), React.createElement("li", null, React.createElement("a", {
    href: "https://member.onlive.vn/app/user_info.php",
    target: "_top",
    className: "myinfo",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "my_info"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "Th\xF4ng tin t\xE0i kho\u1EA3n")))), React.createElement("li", null, React.createElement("a", {
    href: "https://broadstatistic.onlive.vn",
    target: "_top",
    className: "my_stat",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "my_stat"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "Th\u1ED1ng k\xEA c\u1EE7a t\xF4i")))), React.createElement("li", null, React.createElement(DarkMode, null)), React.createElement("li", null, React.createElement("a", {
    href: logoutUrl,
    className: "logout",
    onClick: setClickLogFn("gnb_00000001", {
      button_type: "logout"
    })
  }, React.createElement("span", null, React.createElement(Trans, null, "\uB85C\uADF8\uC544\uC6C3"))))));
});
export default UserArea;